import React from "react";
import MaskedInput from "react-maskedinput";

export default function PersonalIdInput(props) {
  const mask = "1".repeat(10);

  return <MaskedInput mask={mask} placeholder="" {...props} />;
}
